import React, { FunctionComponent, useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { useSwipeable } from 'react-swipeable';
import { IBindingCallback1 } from '../../../../common/models/callback';
import Icon from '../../../../components/Icon';
import RegularButton from '../../../../components/RegularButton';
import { setWorkspaceColorsRoutine } from '../../../../routines/workspace';
import styles from './styles.module.scss';

interface IProps {
  isPreview: boolean;
  setWorkspaceColors: IBindingCallback1<boolean>;
}

const ThankPage: FunctionComponent<IProps> = ({ isPreview, setWorkspaceColors }) => {
  const onOpenLink = () => window.open('https://www.kodiakhr.com/reference-checks');

  const swipeHandler = isPreview ? {} : useSwipeable({
    onSwipedLeft: onOpenLink,
    trackMouse: false
  });

  const textProps = isPreview
    ? { id: 'survey.previewAllDone', defaultMessage: 'All done! You can close this window' }
    : {
      id: 'survey.allDone',
      defaultMessage: `All done! Want to save time and improve your own hiring process with KodiakHR reference 
      checks? Get started today!`
    };

  useEffect(() => {
    setWorkspaceColors(false);
  }, []);

  return (
    <div {...swipeHandler} className="survey-page">
      <div className="d-flex flex-column align-items-center">
        {!isPreview && (
          <>
            <Icon className={`survey-logo ${styles.bearLogo}`} icon="logo" />
            <Icon className={styles.kodiakLogo} icon="kodiakLogo" />
          </>
        )}
        <p className="text-center survey-question-block mb-4">
          <FormattedMessage {...textProps} />
        </p>
        {!isPreview && (
          <div className="mt-2">
            <RegularButton
              iconPosition="right"
              icon={<Icon icon="arrowRight" />}
              textIntlId="survey.allDoneButton"
              defaultMessage="Try KodiakHR"
              size="lg"
              onClick={onOpenLink}
            />
          </div>
        )}
      </div>
    </div>
  );
};

const mapDispatchToProps = {
  setWorkspaceColors: setWorkspaceColorsRoutine
};

export default connect(null, mapDispatchToProps)(ThankPage);
